import { handleErrors } from "@/utils/handle-errors";
import fetch from "@mv/flow-shared-utils/functions/fetch";
export const findByUserAndMenuAndEnvironment = (user: string, menuId: number, environmentId: number) => ({
  type: "findByUserAndMenuAndEnvironment",
  user,
  menuId,
  environmentId,
});

export const actions = {
  findByUserAndMenuAndEnvironment(state: any, { user, menuId, environmentId }: { user: string; menuId: number; environmentId: number }) {
    return fetch(`core/api/exceptlandingpage/user/${user}/menu/${menuId}/environment/${environmentId}`)
      .then(handleErrors)
      .then((data) => data);
  },
};
